import {Avatar, Typography} from '@material-ui/core';
import {ReactElement} from 'react';

const TechCircle = (props: ITechCircleProps) => {
	return (
		<>
			<Avatar className={props.className}>
				{props.icon}
			</Avatar>
			<Typography variant="body2">{props.label}</Typography>
		</>
	);
}

interface ITechCircleProps {
	className: string;
	label: string;
	icon: ReactElement | string,
}

export default TechCircle;
